/*
 * Created on Thu Jun 04 2020
 *
 * Copyright (c) storycraft. Licensed under the MIT Licence.
 */

export enum ClientStatus {

  UNLOCKED = 1,
  LOCKED = 2

}
